import { MenuItem } from '@mui/material'
import { BaseDropdownMenu } from '@common/components/Menu/BaseDropdownMenu'
import { SiteActionMenuProps } from '../types'
import { useCombinedPermissions } from '@auth/hooks/useCombinedPermissions'
import { SitePermission } from '@auth/permissionsEnum'

export default function SiteActionMenu({ anchorEl, onClose, onDelete, onEdit }: Readonly<SiteActionMenuProps>) {
  const { hasAnyPermission } = useCombinedPermissions()
  const canUpdateSite = hasAnyPermission([SitePermission.ALL, SitePermission.CREATE_SITE])
  const canDeleteSite = hasAnyPermission([SitePermission.ALL, SitePermission.REMOVE_SITE])

  return (
    <BaseDropdownMenu anchorEl={anchorEl} onClose={onClose}>
      {canUpdateSite && <MenuItem onClick={onEdit}>Edit Site</MenuItem>}
      {canDeleteSite && <MenuItem onClick={onDelete}>Delete Site</MenuItem>}
    </BaseDropdownMenu>
  )
}
